<template>
    <!-- Pas de fermeture au clic extérieur : seuls la croix et « Annuler » ferment (sans enregistrer). -->
    <div
        v-if="visible"
        class="ppv2-fixed ppv2-inset-0 ppv2-z-[9999] ppv2-flex ppv2-items-center ppv2-justify-center"
        style="background-color: rgba(2, 24, 50, 0.42)"
    >
        <div
            class="ps-card ppv2-relative ppv2-w-[860px] ppv2-max-w-[94vw] ppv2-flex ppv2-flex-col ppv2-bg-white dark:ppv2-bg-dark"
        >
            <!-- En-tête -->
            <div class="ps-header">
                <span class="ps-title poppinsSemiBold">{{ title }}</span>
                <button
                    type="button"
                    class="ps-close"
                    :title="$t('common.close')"
                    :aria-label="$t('common.close')"
                    @click="closeDialog"
                >
                    <X :size="17" />
                </button>
            </div>

            <!-- Corps scrollable -->
            <div class="ppv2-flex-1 ppv2-overflow-y-auto custom-scrollbar" style="padding: 14px 26px 20px">
                <ScheduleDaysEditor ref="scheduleEditor" :days="days" @save="onEditorSave" />
            </div>

            <!-- Pied -->
            <div class="ps-footer">
                <button type="button" class="ps-btn ps-btn--ghost poppinsMedium" @click="closeDialog">
                    {{ $t('common.cancel') }}
                </button>
                <button type="button" class="ps-btn ps-btn--primary poppinsSemiBold" @click="save">
                    {{ $t('common.save') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ScheduleDaysEditor from './ScheduleDaysEditor.vue'
import { X } from 'lucide-vue'

export default {
    name: 'PersonalizeSchedules',
    components: { ScheduleDaysEditor, X },
    props: {
        value: { type: Boolean, required: true },
        days: { type: Array, required: true },
    },
    data() {
        return {
            visible: this.value,
            title: this.$t('experience.step4.multiMode.schedule.titlePopup'),
        }
    },
    watch: {
        value(val) {
            this.visible = val
        },
        visible(val) {
            this.$emit('input', val)
        },
    },
    methods: {
        save() {
            if (this.$refs.scheduleEditor) this.$refs.scheduleEditor.save()
        },
        onEditorSave(payload) {
            this.$emit('schedule-updated', payload)
            this.visible = false
        },
        closeDialog() {
            this.visible = false
        },
    },
}
</script>

<style scoped>
/* Cotes et couleurs : maquette 5a (artifact MSnHmGcueYzToM4iDsYCTN). */
.ps-card {
    max-height: min(740px, calc(100vh - 48px));
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 32px 70px rgba(2, 24, 50, 0.3);
}
.ps-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 20px 26px;
    background: #f3eafa;
}
.ps-title {
    font-size: 18px;
    color: #021832;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.ps-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 32px;
    height: 32px;
    color: #571f84;
    background: transparent;
    border: none;
    border-radius: 9px;
    cursor: pointer;
}
.ps-close:hover {
    background: rgba(87, 31, 132, 0.1);
}
.ps-footer {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 16px 26px;
    background: #f8f9fb;
    border-top: 1px solid #eef1f5;
}
.ps-btn {
    font-size: 14px;
    white-space: nowrap;
    border: none;
    border-radius: 10px;
    padding: 12px 18px;
    cursor: pointer;
    transition:
        background-color 0.15s ease,
        color 0.15s ease;
}
.ps-btn--ghost {
    color: #6b7480;
    background: transparent;
}
.ps-btn--ghost:hover {
    color: #021832;
    background: #eef1f5;
}
.ps-btn--primary {
    padding: 12px 30px;
    color: #fff;
    background: #571f84;
}
.ps-btn--primary:hover {
    background: #45186a;
}

.dark .ps-header {
    background: #1a1f3d;
}
.dark .ps-title {
    color: #fff;
}
.dark .ps-close {
    color: #d7b8f2;
}
.dark .ps-footer {
    background: #151a33;
    border-top-color: #2b3362;
}
.dark .ps-btn--ghost {
    color: #a8b0cc;
}
.dark .ps-btn--ghost:hover {
    color: #fff;
    background: #2b3362;
}
</style>
